import classNames from "classnames"
import React from "react"

interface Props {
  top?: number
  bottom?: number
  children: React.ReactNode
  className?: string
}

const StickyContainer = ({ top, bottom, className, children }: Props) => {
  return (
    <div
      className={classNames("sticky", className)}
      style={{
        top: bottom ? undefined : top,
        bottom,
        zIndex: 2,
      }}
    >
      {children}
    </div>
  )
}

StickyContainer.defaultProps = {
  top: 0,
}

export default StickyContainer
